<template>
    <div>
        financialManagement
    </div>
</template>

<script>
    export default {
        name: 'financialManagement',
    }
</script>

<style lang="scss" scoped>

</style>